import React from "react";

const Footer = () => {
  return (
    <footer>
      Made with <a href="https://reactjs.org/">React</a> @{" "}
      <a href="https://www.lereacteur.io/">Le Reacteur</a> by{" "}
      <a href="https://github.com/jolisdegats">Jolisdegats</a>{" "}
    </footer>
  );
};

export default Footer;
